"use client";

import type { ReactNode } from "react";
import { RahuKaal } from "@/components/rahu-kaal";
import type { MuhuratResponse } from "@/lib/api/muhurat";
import type { SavedCity } from "@/components/choghadiya";
import type { CityWeeklyRahuReference } from "@/components/rahu-kaal/RahuKaal.reference";

export default function RahuKaalClient({
  language = "en",
  heading,
  headingLevel = "h1",
  defaultCity = "New Delhi",
  initialDate,
  initialResult,
  resultOffer,
  crossLinks,
  cityWeeklyReference,
  showAbout,
  initialCity,
  citySelector,
  today,
}: {
  language?: "en" | "hi";
  defaultCity?: string;
  initialDate?: string;
  heading?: string;
  headingLevel?: "h1" | "h2";
  initialResult?: MuhuratResponse | null;
  resultOffer: ReactNode;
  crossLinks: ReactNode;
  cityWeeklyReference?: CityWeeklyRahuReference | null;
  showAbout?: boolean;
  initialCity?: SavedCity;
  citySelector?: ReactNode;
  /** The city's civil date at server render; reserves the "right now" line. */
  today?: string;
}) {
  return (
    <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
      <RahuKaal
        language={language}
        defaultCity={defaultCity}
        initialDate={initialDate}
        heading={heading}
        headingLevel={headingLevel}
        initialResult={initialResult}
        resultOffer={resultOffer}
        crossLinks={crossLinks}
        cityWeeklyReference={cityWeeklyReference}
        showAbout={showAbout}
        initialCity={initialCity}
        citySelector={citySelector}
        today={today}
      />
    </div>
  );
}
